import SliderImages, { SliderImagesProps } from './SliderImages'
export default SliderImages
export { SliderImages, type SliderImagesProps }
